// ============================
// Application Configuration
// ============================

const host = typeof window !== 'undefined' ? window.location.hostname : '';
const isProdHost =
  host === 'famousindianrecipes.com' || host === 'www.famousindianrecipes.com';

const defaultWpBaseUrl = isProdHost
  ? 'https://api.famousindianrecipes.com'
  : 'https://betaapi.famousindianrecipes.com';

const config = {
  WP_URL: process.env.REACT_APP_API_BASE_URL || defaultWpBaseUrl,
  WP_BASE: process.env.REACT_APP_API_BASE_URL || defaultWpBaseUrl+ '/index.php?rest_route=',
};

export default config;
